/*----------------------------------------------------------------------------*\
    FORM.ELEMENTS
    Basic javascript functions for form elements
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.form.elements = {
    init: function(){
        if (oy.cutsMustard) {
            this.initControls();
            this.initSelect();
            this.initPlaceValue();
        }
    },

    initControls: function ($context) {
        if (typeof $context === 'undefined') {
            $context = document.body;
        }
        var $controls = $context.querySelectorAll('.js--control');

        var controlChange = function () {
            var $control = this;
            var $parent = $control.closest('.js--control');

            if ($control.checked) {
                $parent.classList.add('is-checked');
            } else {
                $parent.classList.remove('is-checked');
            }

            if ($control.disabled) {
                $parent.classList.add('is-disabled');
            } else {
                $parent.classList.remove('is-disabled');
            }

            // Garbage collection
            $control = null;
            $parent = null;
        };

        for (var i = 0; i < $controls.length; ++i) {
            var $control = $controls[i];
            var $input = $control.querySelector('.js--control__input');

            $input.onchange = controlChange;
            $input.onchange();
        }

        // Garbage collection
        $controls = null;
    },


    initSelect: function ($context) {
        if (typeof $context === 'undefined') {
            $context = document.body;
        }
        let $selects = $context.querySelectorAll('.js--select');

        [].forEach.call($selects, ($select) => {
            const $selectElement = $select.querySelector('.js--select__element');
            if ($selectElement.disabled) {
                $select.classList.add('is-disabled');
            } else {
                $select.classList.remove('is-disabled');
            }
        });

        // garbage collection
        $selects = null;
    },


    /**
     * Function: initPlaceValue
     * Initialises form input to be placed somewhere else on a page
     */
    initPlaceValue: function ($context) {
        if (typeof $context === 'undefined') {
            $context = document.body;
        }
        var $sources = $context.querySelectorAll('.js--form-place-value__source');

        /**
         * Function: sourceKeyup
         * Replaces the text of the source element with the value in the input
         */
        var sourceKeyup = function () {
            // Get $source element
            var $source = this;
            // Get parent using closest
            var $parent = $source.closest('.js--form-place-value');
            // Find the target
            var $target = $parent.querySelector('.js--form-place-value__target');
            // get the value from the $source
            var val = $source.value;

            // If there is a value, inject otherwise inject initial value
            if (val.length > 0) {
                $target.innerHTML = encodeURI(val.toLowerCase());
            } else {
                $target.innerHTML = $target.dataset.initial;
            }

            // Garbage collection
            $source = null;
            $parent = null;
            $target = null;
            val = null;
        };

        /**
         * Loop over $sources and bind keyup events
         */
        for (var i = 0; i < $sources.length; ++i) {
            var $source = $sources[i];
            $source.onkeyup = sourceKeyup;
        }
    }
};


/**
 * Fire ALL the things
 */
window.addEventListener('load', function () {
    oy.form.elements.init();
}, false);
